import { ChartTooltipModel } from 'chart.js';
import { escape } from '../../../utils/browser/escape';

export const customTooltip = (
  tooltipEl: HTMLElement,
  tooltipModel: ChartTooltipModel,
) => {
  if (tooltipModel.opacity === 0) {
    tooltipEl.style.opacity = '0';
    return;
  }

  if (tooltipModel.body) {
    const [title, x, extraHeader] = tooltipModel.title.map(escape);

    const header = (text: string) => `<tr style="text-align: left;">
        <th colspan="2">${text}</th>
        <tr>
          <td style="padding-right: 15px; text-align: left"><span>${title}</span></td>
          <td style="text-align: right; font-weight: bold;">${x}</td>
        </tr>
      </tr>`;

    tooltipEl.innerHTML = `
      <table>
        ${
  extraHeader
    ? header(extraHeader)
    : `<tr>
                  <th style="padding-bottom: 7px; padding-right: 15px; text-align: left"><span>${title}</span></th>
                  <th style="padding-bottom: 7px; text-align: right;">${x}</th>
              </tr>`
}
        ${tooltipModel.body
    .map(({ lines: [key, value] }, index) => {
      let color;
      if (tooltipModel.displayColors) {
        ({ backgroundColor: color } = tooltipModel.labelColors[
          index
        ] as any);
      }

      return `
              <tr>
                <td style="padding-top: 2px; padding-bottom: 2px;  padding-right: 15px; text-align: left;">
                  ${
  color
    ? `<span style="
                          background-color:${color}; 
                          width: 9px;
                          height: 9px;
                          display: inline-table; 
                          border-radius: 50%; 
                          vertical-align: inherit;
                          "></span>`
    : ''
}
                  <span style="display: inline-block; vertical-align: inherit;">${escape(
    key,
  )}</span>
                </td>
                <td style="padding-top: 2px; padding-bottom: 2px; text-align: right;">
                  <span style="font-weight: bold">${escape(value)}</span>
                </td>
              </tr>`;
    })
    .join('')}
      </table>
      <div class="caret-inner"></div>
      <div class="caret-outer"></div>
    `;
  }
  tooltipEl.style.opacity = '1';
  tooltipEl.style.padding = `${tooltipModel.yPadding}px ${tooltipModel.xPadding}px`;

  const tooltipWidth = tooltipEl.offsetWidth;

  const parentBox = tooltipEl.parentElement.getBoundingClientRect();
  const isTooltipOut = tooltipModel.caretX + tooltipWidth - tooltipModel.xPadding * 2
    > parentBox.width;
  if (isTooltipOut) {
    tooltipEl.style.right = '0px';
    tooltipEl.style.left = '';
  } else {
    tooltipEl.style.left = `${tooltipModel.caretX - tooltipModel.xPadding * 2}px`;
    tooltipEl.style.right = '';
  }
  tooltipEl.style.top = `${tooltipModel.caretY + 7}px`;

  const tooltipCaretInner: HTMLElement = tooltipEl.querySelector(
    '.caret-inner',
  );
  const tooltipCaretOuter: HTMLElement = tooltipEl.querySelector(
    '.caret-outer',
  );
  if (tooltipCaretInner && tooltipCaretOuter) {
    const caretXOffset = Math.min(
      tooltipModel.caretX - tooltipEl.offsetLeft - 5,
      tooltipWidth - tooltipModel.xPadding,
    );
    tooltipCaretInner.style.cssText = `
      position: absolute; 
      top: -5px; 
      left: ${caretXOffset}px; 
      width: 0px; 
      height: 0px; 
      border-style: solid; 
      border-width: 0px 5px 5px 5px; 
      border-color: white transparent;
      z-index: 2;
    `;

    tooltipCaretOuter.style.cssText = `
      position: absolute; 
      top: -8px; 
      left: ${caretXOffset}px; 
      width: 0px; 
      margin-left: -2px;
      height: 0px; 
      border-style: solid; 
      border-width: 0px 7px 8px 7px; 
      border-color: #e7e6e6 transparent;
      z-index: 1;
    `;
  }
};
